/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import your JSON data
import jsonData from './translation.json'; // Replace with the correct path

const resources = {
  en: {
    translation: jsonData, // Use your JSON data for the 'en' language
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en', // Set the default language
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
